<template>
  <div class="staff-attendance">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      :fetchPage="true"
      url="/oa/kaoqing"
      @before-fetch="beforeFetch"
      @after-fetch="afterFetch"
    >
      <el-table-column slot="check" label="录入" fixed="left" width="60">
        <template v-slot="{ row }">
          <el-checkbox v-model="row.check" @change="handleCheck(row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column slot="detail" label="详情" min-width="90" fixed="right">
        <template v-slot="{row}">
          <el-popover placement="left" width="240" trigger="hover" popper-class="detail">
            <div class="item">
              <p>{{row.detail}}</p>
              <el-button @click="copy(row.detail)">复制</el-button>
            </div>
            <el-button type="primary" slot="reference">详情</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </c-table>
    <input class="detail-input" ref="detail">
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'staff-attendance',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    this.detailField = {
      name: '姓名',
      type: '类型',
      betweentime: '起始时间',
      createtime: '申请时间',
      status: '状态',
      day: '天数',
      hour: '小时数',
      detail: '详情',
      code: '单号代码'
    }
    return {
      fields: [
        {
          prop: 'status',
          component: 'radio',
          options: [
            { label: '全部', value: '' },
            { label: '已处理', value: '1' },
            { label: '未处理', value: '0' }
          ],
          value: ''
        },
        {
          prop: 'summary',
          component: 'select',
          options: [
            { label: '详细展示', value: '' },
            { label: '汇总展示', value: '1' }
          ],
          value: ''
        },
        {
          prop: 'type',
          component: 'select',
          clearable: true,
          placeholder: '考勤类型',
          options: [
            { label: '年假', value: '年假' },
            { label: '加班', value: '加班' },
            { label: '事假', value: '事假' },
            { label: '哺乳假', value: '哺乳假' },
            { label: '病假', value: '病假' },
            { label: '加班调休', value: '加班调休' },
            { label: '产假', value: '产假' },
            { label: '销假', value: '销假' },
            { label: '在家办公', value: '在家办公' },
            { label: '产检假', value: '产检假' },
            { label: '陪产假', value: '陪产假' },
            { label: '丧假', value: '丧假' },
            { label: '婚假', value: '婚假' },
            { label: '护理假', value: '护理假' }
          ]
        },
        {
          prop: 'code',
          placeholder: '输入考勤单号代码',
          clearable: true
        },
        {
          prop: 'name',
          placeholder: '员工姓名',
          clearable: true,
          class: 'search_name'
        },
        {
          prop: 'resttime',
          component: 'date-picker',
          type: 'daterange',
          'value-format': 'yyyy-MM-dd',
          'start-placeholder': '考勤开始日期',
          'end-placeholder': '考勤结束日期'
        },
        {
          prop: 'applytime',
          component: 'date-picker',
          type: 'daterange',
          'value-format': 'yyyy-MM-dd',
          'start-placeholder': '申请开始日期',
          'end-placeholder': '申请结束日期'
        }
      ],
      columns: [],
      detailCol: [
        { slot: 'check' },
        { prop: 'code', label: '代码', minWidth: 160 },
        { prop: 'name', label: '姓名', minWidth: 80 },
        { prop: 'createtime', label: '发起时间', minWidth: 170 },
        { prop: 'status', label: '状态', filter: val => { return { 0: '未处理', 1: '已处理', 3: '终止' }[val] }, minWidth: 80 },
        { prop: 'begintime', label: '开始时间', minWidth: 170 },
        { prop: 'endtime', label: '结束时间', minWidth: 170 },
        { prop: 'type', label: '类型', minWidth: 100 },
        { prop: 'day', label: '天数', minWidth: 80 },
        { prop: 'hour', label: '小时数', minWidth: 80 },
        { slot: 'detail' }
      ],
      summaryCol: [
        { prop: 'name', label: '姓名', minWidth: 80 },
        { prop: 'type', label: '类型', minWidth: 100 },
        { prop: 'day', label: '天数', minWidth: 80 },
        { prop: 'hour', label: '小时数', minWidth: 80 }
      ]
    }
  },
  methods: {
    copy(val) {
      const $input = this.$refs.detail
      $input.value = val
      $input.select()
      document.execCommand('Copy')
      this.$message.success('复制成功')
    },
    beforeFetch (params) {
      if (params.resttime) {
        [params.begin, params.end] = params.resttime
        delete params.resttime
      }
      if (params.applytime) {
        [params.begin2, params.end2] = params.applytime
        delete params.applytime
      }
      // 详细展示和汇总展示的列切换
      this.columns = params.summary === '1' ? this.summaryCol : this.detailCol
    },
    afterFetch(res) {
      res.data.data.forEach(item => {
        item.check = +item.check === 1
      })
    },
    handleCheck(row) {
      const checkParams = []
      const unCheckParams = []
      if (row.check) {
        checkParams.push(row.id)
      } else {
        unCheckParams.push(row.id)
      }
      this.$http.post('/oa/kaoqingcheck', {
        check: checkParams,
        uncheck: unCheckParams
      }).then(res => {

      })
    }
  }
}
</script>

<style lang="scss">
.el-popover.detail .item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p { margin-bottom: 12px;}
}
.staff-attendance {
  .c-table {
    .el-form {
      .el-form-item {
        .el-select {
          width: 120px;
          .el-input {
            width: 120px;
          }
        }
        .search_name {
          width: 140px;
          .el-input {
            width: 140px;
          }
        }
      }
    }
  }
  .detail-input {
    position: fixed;
    top: -1000px;
  }
}
</style>
